import React, { useCallback } from 'react';
import { Button, Dropdown } from '../../../../../components';
import { BaseDiscoveryTopBar } from '../../../shared';
import {
    selectableColumns,
    discoveryInventoryDropdownFilters,
} from '../../../Inventory/components/InventoryTopBar/constants';
import { DownOutlined } from '@ant-design/icons';

import './MoveGroupsAndAppsTopBar.scss';

/**
 * MoveGroupsAndAppsTopBar - Extends BaseDiscoveryTopBar with move groups/apps-specific actions
 * Adds: Change Status, Assign buttons
 */
export const MoveGroupsAndAppsTopBar = ({
    selectedColumns,
    handleColumnSelection,
    setSearchValue,
    searchValue,
    handleFilterDiscoveryInventoryData,
    resetFilters,
    refetchInventoryData,
    selectedRowKeys = [],
    selectedFilters,
    setSelectedFilters,
    handleChangeStatus,
    onOpenManageModal,
}) => {
    const statusButtonDropdown = [
        { key: '1', label: 'Mark Ready', onClick: () => handleChangeStatus(selectedRowKeys, 'ready') },
        { key: '2', label: 'Mark Not Ready', onClick: () => handleChangeStatus(selectedRowKeys, 'not_ready') },
    ];

    // Render bulk actions
    const renderBulkActions = useCallback(
        () => (
            <>
                <Dropdown menu={{ items: statusButtonDropdown }} placement="bottomRight" arrow>
                    <Button shape="round" type="primary">
                        Change Status <DownOutlined />
                    </Button>
                </Dropdown>
                <Button shape="round" type="primary" onClick={onOpenManageModal}>
                    Assign
                </Button>
            </>
        ),
        [statusButtonDropdown, onOpenManageModal],
    );

    return (
        <BaseDiscoveryTopBar
            selectedColumns={selectedColumns}
            handleColumnSelection={handleColumnSelection}
            selectableColumns={selectableColumns}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            searchPlaceholder="Search by IP, VM Name, or Hostname"
            searchTooltip="Search by IP, VM Name, or Hostname"
            handleFilterData={handleFilterDiscoveryInventoryData}
            resetFilters={resetFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            filterOptions={discoveryInventoryDropdownFilters}
            refetchData={refetchInventoryData}
            selectedRowKeys={selectedRowKeys}
            renderBulkActions={renderBulkActions}
            showSearchAndFilters={false}
            className="move-groups-apps-top-bar"
        />
    );
};
